import {
  Kidneys,
  Icd10,
  HealthWorkerForm,
  IDocumentsDenied,
  BlisterPillsRoundX4,
} from 'healthicons-react';

/**
 * healthicons-react components that should render inside an AppSquircle for
 * specific apps. These take precedence over the static Phosphor icon map so a
 * widget's sidebar squircle and its in-app header icon stay identical.
 *
 * Colors mirror the squircle tints used elsewhere for these apps.
 */
interface HealthAppIcon {
  component: React.ComponentType<any>;
  color: string;
}

export const HEALTH_APP_ICONS: Record<string, HealthAppIcon> = {
  'phys-crcl': { component: Kidneys, color: '#0891b2' },
  'phys-icd10': { component: Icd10, color: '#047857' },
  'phys-em': { component: HealthWorkerForm, color: '#7c3aed' },
  'phys-denial': { component: IDocumentsDenied, color: '#b45309' },
  'phys-interactions': { component: BlisterPillsRoundX4, color: '#be185d' },
};
